<template>
  <div class="home-main">
    <step-breadcrumb/>
    <div class="user-info" v-if="employeeQuota && fnfQuota">
      {{ $t('Available Rate') }} <br/>{{ $t('Employee Rate') }}{{employeeQuota}} | {{ $t('Friends & Family Rate') }}{{fnfQuota}}
    </div>
    <advance-search/>
    <available-hotels/>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import util from '@/util';
import AdvanceSearch from '@/components/AdvanceSearch.vue'
import StepBreadcrumb from '@/components/StepBreadcrumb.vue'
import AvailableHotels from '@/components/AvailableHotels.vue'

export default {
  name: 'Home',
  components: {
    AdvanceSearch,
    StepBreadcrumb,
    AvailableHotels
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },
  methods: {
    isLogin() {
      // 是否登录  否：跳转登录页
      if(!localStorage.Authorization) {
        this.$router.push({name: 'Login'})
        // 是否强改密码 是：跳转改密码；否：不做操作，正常显示首页；
      } else if (localStorage.isForceChange == 'true') {
        this.$router.push({name: 'UserCenter'})
      }
    },
    gaEvent() {
      let gaData = {
        currentTimeMacau: localStorage.date || '',
        currentTimeLocal: util.dateStr(new Date(), true),
        currentStep: 1,
        cookieId: '',
        skinCode: this.gaData.skinCode,
        memberLoggedIn: false,
      }

      window.dataLayer.push(gaData)
      window._mtm.push({"event": "booking data ready"})
    }
  },
  created() {
    //this.$root.$children[0].gaInit()
    localStorage.removeItem("selects")
    localStorage.removeItem("room")
    if (this.$route.query.skin) {
      const skinCode = this.$route.query.skin
      localStorage.skinCode = skinCode
      this.$store.commit('stateChange', {k: 'gaData', v: Object.assign({}, this.gaData, {skinCode})})
      if (skinCode == 'sjm') {
        document.head.getElementsByTagName('link')[0].href=`${this.publicPath}sjmfavicon.ico`
      } else if (skinCode == 'gl') {
        document.head.getElementsByTagName('link')[0].href=`${this.publicPath}glfavicon.ico`
      } else {
        document.head.getElementsByTagName('link')[0].href=`${this.publicPath}glpfavicon.ico`
      }
    }
    if (this.dataLayerReady) {
      this.gaEvent()
    }
    // 登录状态验证
    this.isLogin()
  },
  computed: {
    ...mapState([
      'dataLayerReady',
      'gaData'
    ]),
    employeeQuota() {
      return this.$store.state.employeeQuota >= 0 ? this.$store.state.employeeQuota : localStorage.employee_quota
    },
    fnfQuota() {
      return this.$store.state.fnfQuota >= 0 ? this.$store.state.fnfQuota : localStorage.fnf_quota
    },
  },
  watch: {
    dataLayerReady(isReady) {
      if (isReady) {
        this.gaEvent()
      }
    }
  }
}
</script>
